import React from 'react';

const PoweredByBuzzback = () => (
  <div className="table_notes-right">
    Powered by <b>buzzback LLC</b>
  </div>
);

export default PoweredByBuzzback;
